import { render, staticRenderFns } from "./ProductoFotos.vue?vue&type=template&id=51fa491f&"
import script from "./ProductoFotos.vue?vue&type=script&lang=js&"
export * from "./ProductoFotos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports